import React from 'react';
import './SourceBadge.css';

export type SourceBadgeVariant = 'indigo-bold' | 'fuchsia-subtle';

interface SourceBadgeProps {
  variant: SourceBadgeVariant;
  children: React.ReactNode;
}

export function SourceBadge({ variant, children }: SourceBadgeProps) {
  return <span className={`source-badge source-badge--${variant}`}>{children}</span>;
}

/** OOTB = indigo bold fill, custom (BYOM) = fuchsia subtle fill, per the Figma. */
export function modelSourceBadgeVariant(source: 'ootb' | 'custom'): SourceBadgeVariant {
  return source === 'ootb' ? 'indigo-bold' : 'fuchsia-subtle';
}
